import { Grid } from "@mui/material";
import Divider from "@mui/material/Divider";
import CommonSelect from "components/CommonSelect/select";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { createRegisterSalesProduct, productsByCompany, updateRegisterSalesProduct } from "rest/requests";
import swal from "sweetalert";

const editSale = (id, productId, year, quarterId, setEditing, newQuantity, newPvp) => {
  updateRegisterSalesProduct(
    id,
    productId,
    String(year),
    quarterId,
    Number(newQuantity),
    Number(newPvp)
  )
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Venta actualizada exitosamente", "success");
      setEditing(false);
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating User: ", error);
      setEditing(false);
    });
};

const createNewSale = (productId, year, quarterId, setEditing, newQuantity, newPvp) => {
  createRegisterSalesProduct(
    productId,
    String(year),
    quarterId,
    Number(newQuantity),
    Number(newPvp)
  )
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Venta creada exitosamente", "success");
      setEditing(false);
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating User: ", error);
      setEditing(false);
    });
};

function EditSalesProduct({
  saleToEdit,
  setEditing,
  selectedCompany,
  selectedYear,
  selectedQuarterId,
}) {
  const [newPvp, setPvNeto] = useState(saleToEdit ? saleToEdit.pvp : 0);
  const [newQuantity, setAmount] = useState(saleToEdit ? saleToEdit.quantity : 0);

  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(
    saleToEdit ? saleToEdit.productId : null
  );

  const getProductsByCompany = useCallback(async () => {
    if (selectedCompany && selectedQuarterId && selectedYear) {
      setProducts(await productsByCompany(selectedCompany));
    }
  }, [selectedCompany, selectedYear, selectedQuarterId]);

  useEffect(() => {
    getProductsByCompany();
  }, [selectedCompany, selectedYear, selectedQuarterId]);

  // Función para manejar cambio en PVP (solo valores positivos)
  const handlePvpChange = (event) => {
    const value = event.target.value;
    // Solo actualiza si es vacío o >= 0
    if (value === "" || Number(value) >= 0) {
      setPvNeto(value);
    }
  };

  // Función para manejar cambio en Cantidad (solo valores positivos)
  const handleQuantityChange = (event) => {
    const value = event.target.value;
    // Solo actualiza si es vacío o >= 0
    if (value === "" || Number(value) >= 0) {
      setAmount(value);
    }
  };

  // Función para prevenir teclas no deseadas
  const preventNegativeKeys = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  return (
    <>
      {saleToEdit ? (
        <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
          <Grid container marginTop={2}>
            <Grid item xs={12} sm={6} padding={1}>
              <MDInput
                variant="outlined"
                type="text"
                label="Producto"
                value={saleToEdit.product.name}
                fullWidth={true}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} padding={1}>
              <MDInput
                variant="outlined"
                type="text"
                label="Codigo"
                value={saleToEdit.product.code}
                fullWidth={true}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={6} padding={1}>
              <MDInput
                variant="outlined"
                type="text"
                label="Presentacion"
                value={saleToEdit.product.presentation}
                fullWidth={true}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} padding={1}>
              <MDInput
                variant="outlined"
                type="text"
                label="Unidad"
                value={saleToEdit.product.unitContent}
                fullWidth={true}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} sm={6} padding={1}>
              <MDInput
                variant="outlined"
                type="number"
                label="PVP ($)"
                value={newPvp}
                fullWidth={true}
                inputProps={{ 
                  min: 0,
                  onKeyDown: preventNegativeKeys 
                }}
                onChange={handlePvpChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} padding={1}>
              <MDInput
                variant="outlined"
                type="number"
                label="Cantidad"
                value={newQuantity}
                fullWidth={true}
                inputProps={{ 
                  min: 0,
                  onKeyDown: preventNegativeKeys 
                }}
                onChange={handleQuantityChange}
              />
            </Grid>
          </Grid>

          <Divider></Divider>

          <Grid container marginTop={2}>
            <Grid item padding={2}>
              <MDButton variant="outlined" color="info" onClick={() => setEditing(false)}>
                Atras
              </MDButton>
            </Grid>

            <Grid item padding={2}>
              <MDButton
                variant="contained"
                color="info"
                onClick={() =>
                  editSale(
                    saleToEdit.id,
                    saleToEdit.productId,
                    saleToEdit.year,
                    saleToEdit.quarterId,
                    setEditing,
                    newQuantity,
                    newPvp
                  )
                }
              >
                Actualizar
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      ) : (
        <div>
          <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
            <Grid container>
              <Grid item padding={1} lg={12} xs={12}>
                <CommonSelect
                  label="Productos"
                  data={products.map((p) => {
                    return {
                      id: p.id,
                      name: [p.name, p.code, p.presentation, p.unitContent].join("-"),
                    };
                  })}
                  onChange={(selectedValue) => setSelectedProductId(selectedValue)}
                ></CommonSelect>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={6} padding={1}>
                <MDInput
                  variant="outlined"
                  type="number"
                  label="PVP ($)"
                  value={newPvp}
                  fullWidth={true}
                  inputProps={{ 
                    min: 0,
                    onKeyDown: preventNegativeKeys 
                  }}
                  onChange={handlePvpChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} padding={1}>
                <MDInput
                  variant="outlined"
                  type="number"
                  label="Cantidad"
                  value={newQuantity}
                  fullWidth={true}
                  inputProps={{ 
                    min: 0,
                    onKeyDown: preventNegativeKeys 
                  }}
                  onChange={handleQuantityChange}
                />
              </Grid>
            </Grid>

            <Divider></Divider>

            <Grid container marginTop={2}>
              <Grid item padding={2}>
                <MDButton variant="outlined" color="info" onClick={() => setEditing(false)}>
                  Atras
                </MDButton>
              </Grid>

              <Grid item padding={2}>
                <MDButton
                  variant="contained"
                  color="info"
                  onClick={() =>
                    createNewSale(
                      selectedProductId,
                      selectedYear,
                      selectedQuarterId,
                      setEditing,
                      newQuantity,
                      newPvp
                    )
                  }
                >
                  Crear
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </div>
      )}
    </>
  );
}

export default EditSalesProduct;

EditSalesProduct.defaultProps = {
  saleToEdit: null,
  setEditing: null,
  selectedCompany: null,
  selectedQuarterId: null,
  selectedYear: null,
};

EditSalesProduct.propTypes = {
  saleToEdit: PropTypes.object,
  setEditing: PropTypes.func,
  selectedCompany: PropTypes.number,
  selectedQuarterId: PropTypes.number,
  selectedYear: PropTypes.number,
};